// services/userApi.ts
import type { User } from "../store/types/userTypes";
import { getGuestId } from "./sessionService";

/**
 * User API Service
 *
 * Handles all user-related API calls
 */
export const userApi = {
  /**
   * Fetch current user from the server
   * Returns the resolved UserDocument (authenticated or guest)
   */
  async fetchCurrentUser(): Promise<User | null> {
    const response = await fetch("/api/users/me", {
      credentials: "include",
      headers: {
        "X-Guest-Id": getGuestId(),
      },
    });

    // 401 means the guest user hasn't been created yet — that's expected.
    // The user will be provisioned on first chat message.
    if (response.status === 401) {
      return null;
    }

    if (!response.ok) {
      throw new Error(`Failed to fetch user: ${response.status}`);
    }

    return await response.json() as User;
  },
};
